var HtmlComponent_default = {
  "htmlComponent": "T-PvN",
  "htmlComponent_placeholder": "OWYRw"
};
export {
  HtmlComponent_default as default
};
//# sourceMappingURL=HtmlComponent-scss.js.map
